import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { NavAdmin } from '@app/shared/components/nav-admin/nav-admin';
import { NavSettings } from '@app/shared/components/nav-settings/nav-settings';
import { ThreePaneLayout } from '@app/shared/components/three-pane-layout/three-pane-layout';

@Component({
  selector: 'app-settings-layout',
  imports: [NavAdmin, NavSettings, RouterOutlet, ThreePaneLayout, TranslatePipe],
  templateUrl: './settings-layout.html',
  styleUrl: './settings-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsLayout {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly isAdminNavigation = signal(this.isAdminRoute(this.router.url));

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => this.isAdminNavigation.set(this.isAdminRoute(event.urlAfterRedirects)));
  }

  protected showAdminNavigation(): void {
    this.isAdminNavigation.set(true);
  }
  protected showSettingsNavigation(): void {
    this.isAdminNavigation.set(false);
  }
  private isAdminRoute(url: string): boolean {
    return url.startsWith('/support') || url.startsWith('/system');
  }
}
